module.exports = __webpack_public_path__ + "static/membershipIllustration-9752ac2cb3e82319711a7b8bdeb36622.svg";